import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { dashboardFeatureStoreKey } from '../feature/dashboard.feature';
import {
  DashboardState,
  RequestStatus,
  SearchedContact,
} from '../state/dashboard.state';

export const getDashboardState = createFeatureSelector<DashboardState>(
  dashboardFeatureStoreKey,
);

export const getSearchedContacts = createSelector(
  getDashboardState,
  (state) => {
    const sContacts: SearchedContact[] = state.searchedContacts?.map(
      (contact: SearchedContact) => {
        return {
          ...contact,
          status:
            contact.status === RequestStatus.REQUEST_SENT &&
            contact.isRequester === false
              ? RequestStatus.REQUEST_RECEIVED
              : contact.status,
          isContactAdded:
            contact.status === RequestStatus.REQUEST_APPROVED ||
            contact.status === RequestStatus.REQUEST_ACCEPTED,
        };
      },
    );
    return sContacts ?? [];
  },
);

export const getSearchedContact = createSelector(
  getDashboardState,
  (state) => state.searchedContact,
);

export const getDashboardNavigationList = createSelector(
  getDashboardState,
  (state) => state.dashBoardNavigaionList,
);

export const getBalancesOverview = createSelector(
  getDashboardState,
  (state) => state.balancesOverview,
);

export const getIsAddContactProcessing = createSelector(
  getDashboardState,
  (state) => state.isAddContactProcessing,
);

export const getRecentTransactionActivities = createSelector(
  getDashboardState,
  (state) => state.recentTransactionActivities,
);

export const getIsRecentTransactionsLoading = createSelector(
  getDashboardState,
  (state) => state.isRecentTransactionsLoading,
);

export const getRecentTransactionsError = createSelector(
  getDashboardState,
  (state) => state.recentTransactionsError,
);

@Injectable({
  providedIn: 'root',
})
export class DashboardSelectors {
  getSearchedContacts$ = this.store.select(getSearchedContacts);
  getSearchedContact$ = this.store.select(getSearchedContact);
  getDashboardNavigationList$ = this.store.select(getDashboardNavigationList);
  getBalancesOverview$ = this.store.select(getBalancesOverview);
  getIsAddContactProcessing$ = this.store.select(getIsAddContactProcessing);
  getRecentTransactionActivities$ = this.store.select(
    getRecentTransactionActivities,
  );
  getIsRecentTransactionsLoading$ = this.store.select(
    getIsRecentTransactionsLoading,
  );
  getRecentTransactionsError$ = this.store.select(getRecentTransactionsError);

  constructor(private store: Store<DashboardState>) {}
}
